export const SAGA_GUARDS = {
  CERTIFICATE: ["SAGA_CERTIFICATE"],
  PAYMENT: ["SAGA_PAYMENT", "SAGA_REGISTRATION"],
  PRODUCT: ["SAGA_PRODUCT"],
  GROUP: ["SAGA_GROUP"],
  QUOTE: ["SAGA_QUOTE"],
  COOKIE_TEMPLATES: ["SAGA_COOKIE_TEMPLATES"],
  EVALUATE_PREMIUM: ["SAGA_EVALUATE_PREMIUM"]
};
